import { render, staticRenderFns } from "./bucket.vue?vue&type=template&id=cfb46fb4"
import script from "./bucket.vue?vue&type=script&lang=js"
export * from "./bucket.vue?vue&type=script&lang=js"
import style0 from "./bucket.vue?vue&type=style&index=0&id=cfb46fb4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports